const DPEDict: Record<string, {
  label: string;
  unit?: string;
  type?: 'string' | 'number' | 'boolean' | 'address' | 'date';
  order?: number;
}> = {
  // Identification
  identifiantDpe: { label: 'Identifiant DPE', type: 'string', order: 0 },
  typeBatiment: { label: 'Type de bâtiment', type: 'string', order: 1 },
  dateReceptionDpe: { label: 'Date de réception', type: 'date', order: 2 },
  estimatedRoomsWithDVF: { label: 'Nombre de pièces (estimé DVF)', type: 'number', order: 3 },
  surfaceHabitableLogement: { label: 'Surface habitable', unit: 'm²', type: 'number', order: 4 },
  surfaceHabitableImmeuble: { label: 'Surface habitable immeuble', unit: 'm²', type: 'number', order: 5 },
  anneeConstruction: { label: 'Année de construction', type: 'string', order: 6 },
  banLabel: { label: 'Adresse', type: 'address', order: 7 },
  complRefLogement: { label: 'Détail de l\'adresse', type: 'string', order: 8 },

  // DPE Classifications
  classeBilanDpe: { label: 'Classe DPE', type: 'string', order: 9 },
  valeurDpe: { label: 'Valeur DPE', unit: 'kWh/m²/an', type: 'number', order: 10 },
  classeBilanGes: { label: 'Classe GES (Gaz à effet de serre)', type: 'string', order: 11 },
  valeurGes: { label: 'Valeur GES (Gaz à effet de serre)', unit: 'kg CO²/m²/an', type: 'number', order: 12 },

  // Energy consumption
  epConso5Usages: { label: 'Consommation énergétique 5 usages', unit: 'kWef/an', type: 'number', order: 13 },
  epConso5UsagesM2: { label: 'Consommation énergétique 5 usages par m²', unit: 'kWef/m²/an', type: 'number', order: 14 },
  epConsoCh: { label: 'Consommation chauffage', unit: 'kWef/an', type: 'number', order: 15 },
  epConsoChDepensier: { label: 'Consommation chauffage (scénario dépensier)', unit: 'kWef/an', type: 'number', order: 16 },
  epConsoEclairage: { label: 'Consommation éclairage', unit: 'kWef/an', type: 'number', order: 17 },
  epConsoEcs: { label: 'Consommation ECS', unit: 'kWef/an', type: 'number', order: 18 },
  epConsoEcsDepensier: { label: 'Consommation ECS (scénario dépensier)', unit: 'kWef/an', type: 'number', order: 19 },
  epConsoFr: { label: 'Consommation refroidissement', unit: 'kWef/an', type: 'number', order: 20 },
  epConsoTotaleAuxiliaire: { label: 'Consommation totale auxiliaires', unit: 'kWef/an', type: 'number', order: 21 },

  // Costs
  cout5Usages: { label: 'Coût total 5 usages', unit: '€', type: 'number', order: 22 },
  coutCh: { label: 'Coût chauffage', unit: '€', type: 'number', order: 23 },
  coutChDepensier: { label: 'Coût chauffage (scénario dépensier)', unit: '€', type: 'number', order: 24 },
  coutEclairage: { label: 'Coût éclairage', unit: '€', type: 'number', order: 25 },
  coutEcs: { label: 'Coût ECS', unit: '€', type: 'number', order: 26 },
  coutEcsDepensier: { label: 'Coût ECS (scénario dépensier)', unit: '€', type: 'number', order: 27 },
  coutTotalAuxiliaire: { label: 'Coût total auxiliaires', unit: '€', type: 'number', order: 28 },

  // Building characteristics
  aspectTraversant: { label: 'Logement traversant', type: 'boolean', order: 29 },
  brasseurAir: { label: 'Brasseur d\'air', type: 'boolean', order: 30 },
  isolationToiture: { label: 'Isolation toiture', type: 'boolean', order: 31 },
  protectionSolaireExterieure: { label: 'Protection solaire extérieure', type: 'boolean', order: 32 },
  inertieLourde: { label: 'Inertie lourde', type: 'boolean', order: 33 },

  // Heat loss
  deperditionBaieVitree: { label: 'Déperdition baies vitrées', unit: 'W/K', type: 'number', order: 34 },
  deperditionEnveloppe: { label: 'Déperdition enveloppe', unit: 'W/K', type: 'number', order: 35 },
  deperditionMur: { label: 'Déperdition murs', unit: 'W/K', type: 'number', order: 36 },
  deperditionPlancherBas: { label: 'Déperdition plancher bas', unit: 'W/K', type: 'number', order: 37 },
  deperditionPlancherHaut: { label: 'Déperdition plancher haut', unit: 'W/K', type: 'number', order: 38 },
  deperditionPontThermique: { label: 'Déperdition ponts thermiques', unit: 'W/K', type: 'number', order: 39 },
  deperditionPorte: { label: 'Déperdition portes', unit: 'W/K', type: 'number', order: 40 },
  deperditionRenouvellementAir: { label: 'Déperdition renouvellement d\'air', unit: 'W/K', type: 'number', order: 41 },

  // Quality indicators
  libTypeEnergie: { label: 'Type d\'énergie', type: 'string', order: 42 },
  libTypeChauffage: { label: 'Type de chauffage', type: 'string', order: 43 },
  libQualEnveloppe: { label: 'Qualité d\'isolation de l\'enveloppe', type: 'string', order: 44 },
  libQualMenuiserie: { label: 'Qualité d\'isolation des menuiseries', type: 'string', order: 45 },
  libQualMurs: { label: 'Qualité d\'isolation des murs', type: 'string', order: 46 },
  libQualPlancherBas: { label: 'Qualité d\'isolation du plancher bas', type: 'string', order: 47 },
  libQualIphtt: { label: 'Qualité d\'isolation de la toiture/planchers hauts toit terrasse', type: 'string', order: 48 },
  libQualPhca: { label: 'Qualité d\'isolation de la toiture/planchers hauts comble aménagé', type: 'string', order: 49 },
  libQualPhcp: { label: 'Qualité d\'isolation de la toiture/planchers hauts comble perdu', type: 'string', order: 50 },

  // Others

  presenceBalcon: { label: 'Balcon (expérimental)', type: 'boolean', order: 51 },
  remplacantId: { label: 'Remplacé par', type: 'string', order: 52 },
  remoteId: { label: 'ID distant', type: 'string', order: 53 },
};

const BauxDict = {
  activitePrincipaleEtablissement: "Activité Principale de l'Établissement",
  activitePrincipaleRegistreMetiersEtablissement: "Activité Principale de l'Établissement au Registre des Métiers",
  activitePrincipaleUniteLegale: "Activité Principale de l'Unité Légale",
  anneeCategorieEntreprise: "Année Catégorie de l'Entreprise",
  caractereEmployeurEtablissement: "Caractère Employeur de l'Établissement",
  categorieEntreprise: "Catégorie de l'Entreprise",
  categorieJuridiqueUniteLegale: "Catégorie Juridique de l'Unité Légale",
  codeCommuneEtablissement: "Code Commune de l'Établissement",
  codePostalEtablissement: "Code Postal de l'Établissement",
  complementAdresseEtablissement: "Complément d'Adresse de l'Établissement",
  coordonneeLambertAbscisseEtablissement: "Coordonnée Lambert Abscisse de l'Établissement",
  coordonneeLambertOrdonneeEtablissement: "Coordonnée Lambert Ordonnée de l'Établissement",
  dateCreationEtablissement: "Date de Création de l'Établissement",
  trancheEffectifsEtablissement: "Tranche effectifs de l'Établissement",
  trancheEffectifsUniteLegale: "Tranche effectifs de l'Unité Légale",
  anneeEffectifsEtablissement: "Année effectifs de l'Établissement",
  anneeEffectifsUniteLegale: "Année effectifs de l'Unité Légale",
  dateCreationUniteLegale: "Date de Création de l'Unité Légale",
  dateDebut: 'Date de Début',
  dateDernierTraitementEtablissement: "Date du Dernier Traitement de l'Établissement",
  dateDernierTraitementUniteLegale: "Date du Dernier Traitement de l'Unité Légale",
  denominationUsuelleEtablissement: "Dénomination usuelle de l'Établissement",
  denominationUniteLegale: "Dénomination de l'Unité Légale",
  denominationUsuelle1UniteLegale: "Dénomination usuelle 1 de l'Unité Légale",
  economieSocialeSolidaireUniteLegale: "Économie Sociale et Solidaire de l'Unité Légale",
  enseigne1Etablissement: "Enseigne 1 de l'Établissement",
  etablissementSiege: 'Établissement Siège',
  etatAdministratifEtablissement: "État Administratif de l'Établissement",
  etatAdministratifUniteLegale: "État Administratif de l'Unité Légale",
  identifiantAdresseEtablissement: "Identifiant Adresse de l'Établissement",
  identifiantAssociationUniteLegale: "Identifiant Association de l'Unité Légale",
  indiceRepetitionEtablissement: "Incide de répétition de l'Établissement",
  libelleCommuneEtablissement: "Libellé Commune de l'Établissement",
  libelleVoieEtablissement: "Libellé Voie de l'Établissement",
  nic: 'NIC',
  nicSiegeUniteLegale: "NIC Siège de l'Unité Légale",
  nombrePeriodesEtablissement: "Nombre de Périodes de l'Établissement",
  nombrePeriodesUniteLegale: "Nombre de Périodes de l'Unité Légale",
  nomenclatureActivitePrincipaleEtablissement: "Nomenclature Activité Principale de l'Établissement",
  nomenclatureActivitePrincipaleUniteLegale: "Nomenclature Activité Principale de l'Unité Légale",
  numeroVoieEtablissement: "Numéro Voie de l'Établissement",
  siren: 'SIREN',
  siret: 'SIRET',
  statutDiffusionEtablissement: "Statut de Diffusion de l'Établissement",
  statutDiffusionUniteLegale: "Statut de Diffusion de l'Unité Légale",
  typeVoieEtablissement: "Type de Voie de l'Établissement",
  idCopro: 'ID de la copropriété',
  nameCopro: 'Nom de la copropriété',
  gestionnaireCopro: 'Gestionnaire de la copropriété',
  leaseEndDate: 'Date de fin de mandat',
  prenomUsuelUniteLegale: 'Prénom du dirigeant de l\'Unité Légale',
  prenom1UniteLegale: 'Prénom usuelle du dirigeant de l\'Unité Légale',
  nomUniteLegale: 'Nom du dirigeant de l\'Unité Légale',
  sexeUniteLegale: 'Sexe du dirigeant de l\'Unité Légale',
};

const BodaccDict = {
  bodaccId: 'ID Bodacc',
  publicationavis: 'Type de publication',
  dateparution: 'Date de parution',
  id: 'ID',
  publicationavisFacette: 'Facette de publication',
  parution: 'Numéro de parution',
  numeroannonce: "Numéro d'annonce",
  typeavis: "Type d'avis",
  typeavisLib: "Libellé du type d'avis",
  familleavis: "Famille d'avis",
  familleavisLib: "Libellé de la famille d'avis",
  numerodepartement: 'Numéro de département',
  departementNomOfficiel: 'Nom officiel du département',
  regionCode: 'Code de région',
  regionNomOfficiel: 'Nom officiel de la région',
  tribunal: 'Tribunal',
  commercant: 'Commerçant',
  ville: 'Ville',
  registre: 'Registre',
  cp: 'Code postal',
  pdfParutionSubfolder: 'Sous-dossier PDF de parution',
  ispdfUnitaire: 'PDF unitaire',
  listepersonnes: 'Liste des personnes',
  listeetablissements: 'Liste des établissements',
  jugement: 'Jugement',
  acte: 'Acte',
  modificationsgenerales: 'Modifications générales',
  radiationaurcs: 'Radiation au RCS',
  depot: 'Dépôt',
  listeprecedentexploitant: 'Liste des précédents exploitants',
  listeprecedentproprietaire: 'Liste des précédents propriétaires',
  divers: 'Divers',
  parutionavisprecedent: "Parution de l'avis précédent",
  etablissementLinked: 'Établissement lié à l\'avis',
  ...BauxDict,
};

export {
  DPEDict, BauxDict, BodaccDict,
};
